<script setup>
const appName = process.env.APP_NAME;
</script>

<template>
    <div class="bg-black relative text-center text-gray-2 text-sm w-full border-t border-t-dark">
        <div class="container py-6 text-center">
            &copy; {{ new Date().getFullYear() }} {{ appName }} All Rights Reserved.
        </div>
    </div>
</template>

<style scoped>

</style>
